<button type="button" class="btnn close_btn" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<div class="modal-box">
  <div class="modal_header modal_banner d_flx">
    <div class="modal_title">
      <h2>{{ "welcomeText" | translate }}</h2>
      <p>{{ "welcomeDescription" | translate }}</p>
      <a class="text_link">{{ "learnMore" | translate }}</a>
    </div>

    <div class="modal_head_figure">
      <figure>
        <img [src]="assetConst.phoneImage" alt="phone" />
      </figure>
    </div>
  </div>

  <div class="modal_body">
    <div class="modal_subtitle">
      <h3>{{ "signIn" | translate }}</h3>
      <p>
        {{
          (loginWithEmail ? "signInemailDescription" : "signInDescription")
            | translate
        }}
      </p>
    </div>

    <form
      [formGroup]="loginFormGroup"
      (ngSubmit)="onSubmit()"
      class="tab_content">
      <ng-container *ngIf="loginWithEmail">
        <div class="form_filed gap_m">
          <div class="form_group">
            <mat-form-field>
              <input
                matInput
                [placeholder]="'enterEmail' | translate"
                formControlName="email"
                type="email"
                class="form_control" />
            </mat-form-field>
            <mat-error
              *ngIf="
                loginFormGroup['controls']['email'].hasError('required') &&
                submitted
              ">
              {{ "email" | translate }} {{ "isRequired" | translate }}
            </mat-error>
            <mat-error
              *ngIf="
                loginFormGroup['controls']['email'].hasError('pattern') &&
                submitted
              ">
              {{ "PleaseEnterValid" | translate }}
              {{ "email" | translate }}
            </mat-error>
          </div>

          <div class="form_group">
            <mat-form-field>
              <input
                matInput
                [placeholder]="'EnterPassword' | translate"
                class="form_control"
                [type]="hide ? 'password' : 'text'"
                formControlName="password" />
            </mat-form-field>
            <span (click)="hide = !hide" class="pass_ico">
              <mat-icon>{{ !hide ? "visibility" : "visibility_off" }}</mat-icon>
            </span>
            <mat-error
              *ngIf="
                submitted &&
                loginFormGroup.controls['password'].hasError('required')
              ">
              {{ "Password" | translate }} {{ "isRequired" | translate }}
            </mat-error>
          </div>

          <div class="form_group rem_sec">
            <mat-checkbox
              [checked]="isRemembered"
              (change)="toggleRememberMe($event)">
              {{ "remember" | translate }}
            </mat-checkbox>
            <p (click)="forgotPass()" class="cursor_pointer">
              {{ "forgotPassword" | translate }}
            </p>
          </div>
        </div>
      </ng-container>

      <div *ngIf="!loginWithEmail" class="form_group phone-input">
        <ngx-mat-intl-tel-input
          name="phone"
          [preferredCountries]="['ly']"
          describedBy="phoneInput"
          formControlName="phoneNo"
          #phone
          (countryChanged)="countryChangedEvent($event)">
        </ngx-mat-intl-tel-input>
      </div>
      <mat-error
        *ngIf="
          submitted &&
          (loginFormGroup.get('phoneNo')?.value === '' ||
            loginFormGroup.get('phoneNo')?.value === null) &&
          loginFormGroup.get('phoneNo')?.hasError('required')
        ">
        {{ "PhoneNumber" | translate }}
        {{ "isRequired" | translate }}
      </mat-error>
      <mat-error
        *ngIf="
          submitted &&
          (loginFormGroup.get('phoneNo')?.value === undefined ||
            loginFormGroup.get('phoneNo')?.hasError('validatePhoneNumber'))
        ">
        {{ "PleaseEnterValid" | translate }}
        {{ "PhoneNumber" | translate }}
      </mat-error>

      <div class="submit_btn mt_20">
        <button type="submit" class="btnn btn_primary">
          {{ "continue" | translate }}
        </button>
      </div>
    </form>

    <button type="button" class="email_login" (click)="loginTypeChanged()">
      {{ (loginWithEmail ? "loginWithPhone" : "loginWithEmail") | translate }}
    </button>

    <div class="or-box">
      <p>{{ "or" | translate }}</p>
    </div>

    <ul class="social-login">
      <!-- <li>
        <i class="fa-brands fa-facebook-f"></i>
      </li> -->
      <li>
        <asl-google-signin-button
          type="icon"
          size="large"
          (click)="socialLogin()">
        </asl-google-signin-button>
      </li>
    </ul>

    <p class="signup_text">
      {{ "notMember" | translate }}
      <button type="button" (click)="SignUp()">
        {{ "signUp" | translate }}
      </button>
    </p>
  </div>
</div>
